<template>
	<div class="pb-2">
		<userAutoComplete :place="schema.placeholder" v-on:selected="setValue" />

		<div class="users-list-w">
			<div class="user-w with-status" :class="(selectedFrom.online) ? 'status-green' : 'status-red'" v-if="selected" v-for="selectedFrom in selected">
				<div class="user-name">
					<h6 class="user-title">{{ selectedFrom.name }}</h6>
					<div class="user-role">{{ selectedFrom.username }}</div>
					<div class="user-role">{{ t.user.balance }}: {{ selectedFrom.balance | toMoney( selectedFrom.currency ) }}</div>
					<div class="user-role">{{ t.user.credit }}: {{ selectedFrom.credit | toMoney( selectedFrom.currency ) }}</div>
				</div>
				<a class="user-action" href="javascript:;">
					<div v-on:click="findByKeyAndRemove(selected, 'id', selectedFrom.id)" class="os-icon os-icon-cancel-circle"></div>
				</a>
			</div>
		</div>
		<input
				class="form-control"
				type="hidden"
				v-model="value"
				:disabled="disabled"
				:maxlength="schema.max"
				:placeholder="schema.placeholder"
				:readonly="schema.readonly" >
	</div>
</template>

<script>
    import userAutoComplete from '@/components/autocomplete/userAutoComplete'
    import { abstractField } from "vue-form-generator";

    export default {
        name: 'vfg-field-user',
	    components: { userAutoComplete },
        mixins: [ abstractField ],
        data () {
            return {
                t: this.$root.t,
                result: null,
                selected: [],
                q: '',
            }
        },
        watch: {
            'selected' (o, n) {
                this.value = [];
                if (this.schema.multi) {
                    if (this.schema.onlyId) {

						this.selected.forEach((val) => {
                            this.value.push(val.id);
                        });

                    }else {
                        this.value = this.selected;
                    }
                }
            }
        },
	    mounted () {
			if (this.schema.data) {
                this.selected = this.schema.data;
			}else {
                this.value = [];
                this.selected = [];
			}
	    },
        methods: {

            clear () {
                if(!this.q) {
                    this.result = null;
                    this.value = [];
                }
            },
            setValue (val, tit) {
                if(val) {
                    if (this.schema.multi) {
                        if (this.schema.onlyId) {
                            this.value.push(val.id);
                        }else  {
                            this.value.push(val);
                        }

                        this.selected.push(val);
                    }else {
                        this.value = val.id;
                        this.selected.push(val);
                    }

                    this.q = tit;
                    this.result = null;
                }else {
                    this.result = null;
                    this.value = [];
                }

            },
            search (q) {

                this.$http.get(bsapi+'api/v1/search/fixture?q='+this.q+'&type=competitor').then(response => {
                    // get body data
                    this.result = (q) ? response.body.result : null;
                    this.value = [];
                }, response => {
                    this.value = [];
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.list-group {
		background: #fff;
		list-style: none
	}
	.list-group .list-group-item{
		border-bottom: 1px solid #ccc;
		padding: 0px 5px 0px 5px;

	}
</style>



// WEBPACK FOOTER //
// src/components/form/fieldUser.vue